import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS,ALL_MESSAGES} from '../utils/logger';

export const MODULE_NAME = 'VAT_CODES_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UPDATE = namespaced('UPDATE');
const UPDATE_PROGRESS = namespaced('UPDATE_PROGRESS');
const UPDATE_OK = namespaced('UPDATE_OK');
const UPDATE_FAIL = namespaced('UPDATE_FAIL');
const CREATE = namespaced('CREATE');
const CREATE_OK = namespaced('CREATE_OK');
const CREATE_FAIL = namespaced('CREATE_FAIL');
const IMPORT_CUSTOM_VAT_CODES = namespaced('IMPORT_CUSTOM_VAT_CODES');
const IMPORT_CUSTOM_VAT_CODES_OK = namespaced('IMPORT_CUSTOM_VAT_CODES_OK');
const IMPORT_CUSTOM_VAT_CODES_FAIL = namespaced('IMPORT_CUSTOM_VAT_CODES_FAIL');
const EXPORT_VAT_CODES = namespaced('EXPORT_VAT_CODES');
const EXPORT_VAT_CODES_OK = namespaced('EXPORT_VAT_CODES_OK');
const EXPORT_VAT_CODES_FAIL = namespaced('EXPORT_VAT_CODES_FAIL');
const DELETE = namespaced('DELETE');
const DELETE_OK = namespaced('DELETE_OK');
const DELETE_FAIL = namespaced('DELETE_FAIL');
const DUPLICATE_VATCODE = namespaced('DUPLICATE_VATCODE');
const CANCEL_DUPLICATE_VATCODE = namespaced('CANCEL_DUPLICATE_VATCODE');
const TOGGLE_VATCODE_SELECTION = namespaced('TOGGLE_VATCODE_SELECTION');
const CLEAR_VATCODE_SELECTION = namespaced('CLEAR_VATCODE_SELECTION');
const SELECT_VATCODES = namespaced('SELECT_VATCODES');
const IMPORT_GENERIC_VAT_CODES = namespaced('IMPORT_GENERIC_VAT_CODES');
const IMPORT_GENERIC_VAT_CODES_OK = namespaced('IMPORT_GENERIC_VAT_CODES_OK');
const IMPORT_GENERIC_VAT_CODES_FAIL = namespaced('IMPORT_GENERIC_VAT_CODES_FAIL');
const CLEAR_ERRORS = namespaced('CLEAR_ERRORS');
const CLEAR_VAT_CODES = namespaced('CLEAR_VAT_CODES');

export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  UPDATE,
  UPDATE_PROGRESS,
  UPDATE_OK,
  UPDATE_FAIL,
  CREATE,
  CREATE_OK,
  CREATE_FAIL,
  IMPORT_CUSTOM_VAT_CODES,
  IMPORT_CUSTOM_VAT_CODES_OK,
  IMPORT_CUSTOM_VAT_CODES_FAIL,
  DELETE,
  DELETE_OK,
  DELETE_FAIL,
  DUPLICATE_VATCODE, 
  CANCEL_DUPLICATE_VATCODE,
  TOGGLE_VATCODE_SELECTION,
  CLEAR_VATCODE_SELECTION,
  SELECT_VATCODES,
  IMPORT_GENERIC_VAT_CODES,
  IMPORT_GENERIC_VAT_CODES_OK,
  IMPORT_GENERIC_VAT_CODES_FAIL,
  EXPORT_VAT_CODES,
  EXPORT_VAT_CODES_OK,
  EXPORT_VAT_CODES_FAIL, 
  CLEAR_ERRORS,
  CLEAR_VAT_CODES
};

export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null, progress: undefined});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      case UPDATE:
        return Object.assign({}, state, {loading: true, error: null, progress: action.progress, importFailures: null});
      case UPDATE_PROGRESS:
        return Object.assign({}, state, {error: null, progress: action.progress});
      case UPDATE_OK:
        return Object.assign({}, state, {loading: false, error: null, progress: undefined, failures : null});
      case UPDATE_FAIL:
        return Object.assign({}, state, {loading: false, failures: action.failures});
      case DELETE:
      case EXPORT_VAT_CODES:
        return Object.assign({}, state, {loading: true, failures: null});
      case DELETE_OK:
        return Object.assign({}, state, { selectedIds:undefined, codes:undefined, data: undefined, loading:false, error: null});
      case DELETE_FAIL:
      case EXPORT_VAT_CODES_FAIL:
        return Object.assign({}, state, {loading: false, failures: action.failures});
      case CREATE:
      case IMPORT_CUSTOM_VAT_CODES:
        return Object.assign({}, state, {loading: true, error: null, progress: action.progress, importFailures: null});
      case CREATE_OK:
      case IMPORT_CUSTOM_VAT_CODES_OK:
      case EXPORT_VAT_CODES_OK:
        return Object.assign({}, state, {loading: false, error: null, progress: undefined, duplicateVatCode: undefined,
          failures: null, importFailures: null, createfailures: null });
      case CREATE_FAIL:
      case IMPORT_CUSTOM_VAT_CODES_FAIL:
        return Object.assign({}, state, {loading: false, failures: null, createfailures: action.failures, 
                                importFailures: action.importFailures, genericVatCodesImportError: null, error: action.error});
      case CLEAR_ERRORS:
        return Object.assign({}, state, {importFailures: null});
      case DUPLICATE_VATCODE:
        return Object.assign({}, state, {duplicateVatCode: action.duplicateVatCode, importFailures: null});
      case CANCEL_DUPLICATE_VATCODE:
        return Object.assign({}, state, {duplicateVatCode: undefined});
      case TOGGLE_VATCODE_SELECTION:
      {
        let allIds = [];
        if (state.selectedIds && (state.selectedIds.length > 0))
        {
          allIds = state.selectedIds.slice();
        }
        
        let idIndex = allIds.indexOf(action.vatCodeId);
        if (idIndex < 0){
          allIds.push(action.vatCodeId) 
        }
        else{
          allIds.splice(idIndex, 1);
        }
        return Object.assign({}, state, {selectedIds: allIds});
      }
      case CLEAR_VATCODE_SELECTION:
        return Object.assign({}, state, {selectedIds: []});
      case SELECT_VATCODES:
      {
        let allIds = action.vatCodes;
        return Object.assign({}, state, {selectedIds: allIds});
      }
      case IMPORT_GENERIC_VAT_CODES:
      {
        return Object.assign({}, state, {loading: true, genericVatCodesImportError: null});
      }
      case IMPORT_GENERIC_VAT_CODES_OK:
      {
        return Object.assign({}, state, {loading: false, genericVatCodesImportError: null});
      }
      case IMPORT_GENERIC_VAT_CODES_FAIL:
      {
        return Object.assign({}, state, {loading: false, genericVatCodesImportError: action.error});
      }
      case CLEAR_VAT_CODES:
        return Object.assign({}, state, {data: undefined});    
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

const FilterVatCodes = (params) => {
  log.debug('FilterVatCodes(params): ', params);
  // get all from API
  return (dispatch, getState) => {
    dispatch({type: LOAD});
    CLIENT.getVATCodes(params)
      .then((response) => {
        log.debug('FilterVatCodes: success: ', response );
        dispatch({type: LOAD_OK, response: response});
      })
      .catch((error) => {
        log.debug('FilterVatCodes: failure: ', error );
        dispatch({type: LOAD_FAIL, error});
      });
  }
};


export const API = {
  doDeleteVatCode: (id, filterParams) => {
    return (dispatch, getState) => {
      log.debug('doDeleteVatCode controller: id: ', id);
      dispatch({type: DELETE});
      log.clearAllDictionaryErrors();

      CLIENT.deleteVATCode(id)
        .then((response) => {
          log.debug('doDeleteVatCode: success: ', response);
          log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_DELETED_SUCCESSFULLY);
          dispatch({type: DELETE_OK, response: response});
        })
        .then(()=> {dispatch(FilterVatCodes(filterParams))})
        .catch((error) => {
          log.debug('doDeleteVatCode: failure: ', error);
          log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_DELETE_FAILURE);
          dispatch({type: DELETE_FAIL, error});
        })
    }
  },
  doDeleteMultipleVatCodes: (ids, filterParams) =>{
    return (dispatch) => {
      Promise.all(
        ids.map(id => CLIENT.deleteVATCode(id))
      )
      .then((response) => {
        log.debug('doDeleteMultipleVatCodes response:',response);
        dispatch({type: DELETE_OK, response: response});
      })
      .then(()=> {dispatch(FilterVatCodes(filterParams))})
      .catch((error) => {
        log.debug('doDeleteMultipleVatCodes: failure: ', error);
        dispatch({type: DELETE_FAIL, error});
      })
    }
  },
  doUpdateVatCode: (formData, filterParams) => {
    return (dispatch, getState) => {
      const id =  formData.fieldValues.id;
      const body = formData.fieldValues;

      log.debug('doUpdateVatCode controller: formData: ', formData);
      dispatch({type: UPDATE});
      log.clearAllDictionaryErrors();

      CLIENT.updateVATCode(id, body)
        .then((response) => {
          log.debug('doUpdateVatCode: success: ', response);
          log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_UPDATED_SUCCESSFULLY);
          dispatch({type: UPDATE_OK, response: response})
        })
        .then(()=> {dispatch(FilterVatCodes(filterParams))})
        .catch((error) => {
          let errorDetails = error.status;
          switch(error.status){
            case 409:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_ALREADY_EXISTS);
              break;
            case 400:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_UPDATE_400);
              break;
            default:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_UPDATE_UNKNOWN_ERROR)
          }
          dispatch({type: UPDATE_FAIL, error : errorDetails})
        })
    }
  },
  doCreateVatCodeByTransactionId: (body, filterParams) => {
    return (dispatch) => {
      log.debug("doCreateVatCodeByTransactionId: body: ", body);
      dispatch({type: CREATE });
      log.clearAllDictionaryErrors();

      CLIENT.createVATCodeWithTransactionId(body)
        .then((response) => {
          log.debug('doCreateVatCodeByTransactionId: success: ', response);
          log.clearAllDictionaryErrors();

          log.debug('doCreateVatCodeByTransactionId combinationIDInvoice:', response.combinationIDInvoice);
          switch (response.combinationIDInvoice){
            case -9999:
              log.debug('doCreateVatCodeByTransactionId: "Do you really wish to setup this transaction for this country, as we examined that this does not exist."')
              log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_UNSUPPORTED_9999);
              break;
            case -9000:
              log.debug('doCreateVatCodeByTransactionId: "This transaction has not yet been fully checked. If you need it, please contact the support team for an update."')
              log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_UNSUPPORTED_9000);
              break;
            default:
              dispatch({type: CREATE_OK, response: response});
              log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_CREATED_SUCCESSFULLY);
          }
        })
        .then(()=> {dispatch(FilterVatCodes(filterParams))})
        .catch((error) => {
          let errorDetails = error.status;
          switch(error.status){
            case 409:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_ALREADY_EXISTS);
              break;
            case 400:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_CREATE_400);
              break;
            default:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_CREATE_UNKNOWN_ERROR);
          }
          log.debug('doCreateVatCodeByTransactionId: failure: ', errorDetails);
          dispatch({type: CREATE_FAIL, error: errorDetails});
        })
    }
  },
  doCreateVatCodeByDuplicate: (formData, filterParams) => {
    return (dispatch, getState) => {
      const body = formData.fieldValues;

      log.debug('doCreateVatCodeByDuplicate controller: formData: ', formData);
      dispatch({type: CREATE});
      log.clearAllDictionaryErrors();

      CLIENT.createVATCode(body)
        .then((response) => {
          log.debug('doCreateVatCodeByDuplicate: success: ', response);
          log.setDictionaryMessage(ALL_MESSAGES.VAT_CODE_CREATED_SUCCESSFULLY);
          dispatch({type: CREATE_OK, response: response})
        })
        .then(()=> {dispatch(FilterVatCodes(filterParams))})
        .catch((error) => {
          let errorDetails = error.status;
          switch(error.status){
            case 409:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_ALREADY_EXISTS);
              break;
            case 400:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_UPDATE_400);
              break;
            default:
              log.setDictionaryMessage(ALL_MESSAGES.VATCODE_UPDATE_UNKNOWN_ERROR)
          }

          log.debug('doCreateVatCodeByDuplicate: failure: ', error);
          dispatch({type: CREATE_FAIL, error: errorDetails})
        })
    }
  },
  doImportGenericVatCodes: (removeExistingVatCodes, filterParams) => {
    return (dispatch) => {
      log.debug('doImportGenericVatCodes controller');
      dispatch({type: IMPORT_GENERIC_VAT_CODES});
      CLIENT.importGenericVatCodes(removeExistingVatCodes)
        .then((response) => {
          log.debug('doImportGenericVatCodes: success: ', response);
          dispatch({type: IMPORT_GENERIC_VAT_CODES_OK, response: response})
        })
        .then(()=> {dispatch(FilterVatCodes(filterParams))})
        .catch((error) => {
          log.debug('doImportGenericVatCodes: failure: ', error);
          dispatch({type: IMPORT_GENERIC_VAT_CODES_FAIL, error})
        })
    }
  },
  doImportCustomVatCodes: (vatCodesFile, removeExistingVatCodes, filterParams) => {
    return (dispatch, getState) => {

      dispatch({type: IMPORT_CUSTOM_VAT_CODES});

      CLIENT.createCustomVATCodes(vatCodesFile, removeExistingVatCodes)
        .then((response) => {
          log.debug('doImportCustomVatCodes: success: ', response);
          dispatch({type: IMPORT_CUSTOM_VAT_CODES_OK, response: response})
        })
        .then(()=> {dispatch(FilterVatCodes(filterParams))})
        .catch((error) => {
          log.debug('doImportCustomVatCodes: failure: ', error);
          dispatch({type: IMPORT_CUSTOM_VAT_CODES_FAIL, importFailures: error})
        })
    }
  },
  doExportVatCodes: (callback) => {
    return (dispatch, getState) => {
        log.debug('doExportVatCodes controller');
        dispatch({type: EXPORT_VAT_CODES});
        return CLIENT.exportVatCodes()
            .then((response) => {
                dispatch({type: EXPORT_VAT_CODES_OK, response: response});
                if(typeof callback === 'function') {
                  callback(null, response);
                }
            })
            .catch((error) => {
                dispatch({type: EXPORT_VAT_CODES_FAIL, error});
                if(typeof callback === 'function') {
                  callback(error, null);
                }
            });
      }
  },
  doDuplicateVatCode: (duplicateVatCode) => {
    return (dispatch, getState) => {
      dispatch({type: DUPLICATE_VATCODE, duplicateVatCode: duplicateVatCode});
    }
  },
  doClearErrorMessages: () => {
    return (dispatch, getState) => {
      dispatch({type: CLEAR_ERRORS});
    }
  },
  doCancelDuplicateVatCode: () => {
    return (dispatch, getState) => {
      dispatch({type: CANCEL_DUPLICATE_VATCODE});
    }
  },
  doToggleVatCodeSelection: (vatCodeId) => {
    return (dispatch, getState) => {
      dispatch({type: TOGGLE_VATCODE_SELECTION, vatCodeId: vatCodeId});
    }
  },
  doClearVatCodeSelection: () => {
    return (dispatch, getState) => {
      dispatch({type: CLEAR_VATCODE_SELECTION, id: 3});
    }
  },
  doSelectVatCodes: (vatCodes) => {
    return (dispatch, getState) => {
      dispatch({type: SELECT_VATCODES, vatCodes});
    }
  },
  doClearVATCodes: () => {
    return (dispatch, getState) => {
      dispatch({type: CLEAR_VAT_CODES});
    }
  },
  doFilterVatCodes: FilterVatCodes
};

export default API;